export const ENDPOINTS = {
  USER_EXTENDED_PREVIEWS: "/extended_user_previews",
  USER_CORRECTIBLE: "/correctible_previews",
  AGENT_CORRECTIBLE: "/correctible_previews",
  FORMER_CORRECTIBLE: "/correctible_previews_former",
  SUBMIT_CORRECTIBLE: "/correctionRequest",
  SUBMIT_CORRECTIBLE_FORMER: "/correctionRequestFormer",
  FETCH_DELETE_CATEGORIES: "/delete/categories",
  REQUEST_DOWNLOAD: "/downloadRequest",
  REQUEST_DELETE: "/deleteRequest",
  CANCEL_DOWNLOAD: "/cancel/downloadRequest",
  CANCEL_DELETE: "/cancel/delete",
  FETCH_REQUEST_HISTORY: "/request_history",
  REQUEST_STATUS: "/request_status",
  SEND_SECURE_PIN_TO_DEVICE: "/request_PIN",
  SEND_SECURE_PIN_WIRELINE: "/request_PIN_wireline",
  SEND_SECURE_PIN_OTT: "/request_PIN_ott",
  SEND_SECURE_PIN_CVA: "/request_PIN_cva",                                 //developer Arvind
  SEND_SECURE_PIN_FAMILY_APP: "/request_PIN_familyapp",                    //developer Arvind
  SEND_SECURE_PIN_VILS: "/request_PIN_vils",
  SEND_SECURE_PIN_FAMILY_MONEY: "/request_PIN_nico",
  VALIDATE_SECURE_PIN: "/validate_PIN",
  FETCH_PROFILE: "/retrieve_profile",
  CHECK_IF_MDN_SMS_CAPABLE: "/verify_sendpin",
  RENEW_USER_SESSION: "/renew_user_session",
  RESEND_PASSWORD: "/resend_file_password",
  SUBMIT_CONSENTED_DATE: "/submit_consented_date",
  FETCH_DOWNLOAD_PAGES: "/content/download",
  FETCH_HISTORY_PAGE: "/content/requesthistory",
  FETCH_DOWNLOAD_STATUS_PAGES: "/content/downloadstatus",
  FETCH_DELETE_PAGES: "/content/deletepage",
  FETCH_GUEST_DOWNLOAD_STATUS_PAGES_NEW: "/content/downloadstatusguest",

  FETCH_WIRELINE_LANDING_PAGE: "/content/landingpagewireline",
  FETCH_WIRELESS_LANDING_PAGE: "/content/landingpage",
  FETCH_WIRELINE_DOWNLOAD_PAGES: "/content/downloadwireline",
  FETCH_WIRELINE_DELETE_PAGES: "/content/deletepagewireline",
  FETCH_WIRELINE_STATUS_PAGES: "/content/downloadstatuswireline",
  FETCH_OTT_STATUS_PAGES: "/content/downloadstatusott",
  FETCH_CVA_STATUS_PAGES: "/content/downloadstatuscva",
  FETCH_ACCOUNT_NOT_SUPPORTED_PAGE: "/content/accountnotsupported",
  FETCH_IVR_PAGES: "/content/ivrpage",
  FETCH_OTT_LANDING_PAGE: "/content/landingpageott",
  FETCH_SIGNIN_PAGE: "/content/signin",
  FETCH_OTT_DOWNLOAD_PAGES: "/content/downloadott",
  FETCH_WIRELINE_SUB_ACCOUNT_PAGE: "/content/wirelinesubaccount",
  FETCH_CXP_DOWN_PAGE: "/content/cxpdown",
  FETCH_BE_CUSTOMER_PAGE: "/content/becustomer",
  FETCH_DISCONNECTED_PAGE: "content/disconnectedcustomer",
  FETCH_ACCOUNT_DISCONNECTED_PAGE: "content/accountdisconnectedcustomer",
  FETCH_ASSIGN_AUTHORIZED_AGENT_WIRELESS_PAGE: "content/assignagentwireless",
  FETCH_ASSIGN_AUTHORIZED_AGENT_WIRELINE_PAGE: "content/assignagentwireline",
  FETCH_ASSIGN_AUTHORIZED_AGENT_OTT_PAGE: "content/assignagentott",
  FETCH_AUTHORIZED_AGENT_LANDING_PAGE: "content/agentlandingpage",
  FETCH_AUTHORIZED_AGENT_DELETE_PAGE: "content/agentdeletepage",
  FETCH_AUTHORIZED_AGENT_DOWNLOAD_PAGES: "content/agentdownload",
  FETCH_AUTHORIZED_AGENT_CORRECTIBLE: "content/agentcorrection",
  FETCH_AUTHORIZED_AGENT_DOWNLOAD_STATUS_PAGES: "content/agentdownloadstatus",
  FETCH_FORMER_CUSTOMER_DELETE_PAGES_NEW: "content/formerdeletepagenew",
  FETCH_FAMILY_MONEY_LANDING_PAGE: "content/landingpagenico",
  FETCH_FAMILY_MONEY_DOWNLOAD_PAGES: "content/downloadnico",
  FETCH_VILS_LANDING_PAGE: "content/landingpagevils",
  FETCH_VILS_DOWNLOAD_PAGES: "content/downloadvils",
  LOGOUT: "/privacy/secure/logout",
  FETCH_MARKETING_PREFERENCES: "/getOptOutData",
  SET_MARKETING_PREFERENCES: "/setOptOutData",
  SUBMIT_AUTH_AGENT_INFO: "/request_associateAgent",
  SUBMIT_APPEAL_FORM: "/appealRequest",
  CANCEL_APPEAL: "/cancel/appealRequest",
  CANCEL_CORRECTION: "/cancel/correctionRequest",
  AGENT_FETCH_CUSTOMER_HISTORY: "/retrieve_customer_history",
  AGENT_DELETE_REQUEST: "/delete_request",
  AGENT_DOWNLOAD_REQUEST: "/download_request",
  AGENT_DOWNLOAD_FILE: "/privacy/secure/api/agent/download/file",
  AGENT_CANCEL_DOWNLOAD: "/cancel/downloadRequest",
  AGENT_SUBMIT_APPEAL_FORM: "/appealRequest",
  AGENT_SUBMIT_CORRECTIBLE: "/correctionRequest",
  UPDATE_AGENT_ASSOCIATION: "/update_agent_association",
  UPDATE_AUTH_AGENT: "/update_agentAssociate",
  FORCE_LOGOUT: "/privacy/secure/forceLogout",
  VERIFY_FORMER_CUSTOMER: "/fetch_former_customer_accts",
  DELETE_FORMER_PERSONAL_DATA: "/deleteRequestFormer",
  GUEST_FLOW_MFA_REQUEST_PIN: "/request_PIN_GuestOrFormer",
  GUEST_FLOW_MFA_VALIDATE_PIN: "/validate_PIN_GuestOrFormer",
  FETCH_TIMEOUT_PAGE: "content/timeoutpage",
  FETCH_FORMER_CUSTOMER_LANDING_NEW: "content/formerlandingpagenew",
  FETCH_FORMER_CUSTOMER_DOWNLOAD_PAGES_NEW: "content/formerdownloadnew",
  FORMER_DOWNLOAD_CREATE_UPDATE_PROFILE: "/am_createorupdateprofile",
  FORMER_DOWNLOAD_PENDING_CASE: "/fetch_former_pending_case",
  FORMER_DOWNLOAD_CREATE_CASE: "/createorupdate_former_case_id",
  FORMER_DOWNLOAD_ADDRESS_DOB_DATA: "/address_dob_update_former",
  FORMER_CREATE_TIME_FRAME: "/time_frame_download_former",
  FORMER_CREATE_FILE_FORMAT: "/select_file_download_former",
  FORMER_CREATE_DOC_VERIFICATION: "/document_verification_download_former",
  FETCH_FORMER_CUSTOMER_CORRECTION_PAGE_NEW: "content/formercorrectionnew",
  CLOSE_CASEID: "close_case_download_former/",
  FETCH_GUEST_FLOW_LANDING_NEW: "/content/landingpageguestnew",
  FETCH_GUEST_DELETE_PAGE_NEW: "/content/deletepageguestnew",
  FETCH_GUEST_DOWNLOAD_PAGES_NEW: "/content/downloadpageguestnew",
  FETCH_FORMER_REQUEST_HISTORY: "/content/formerrequesthistory",
  FETCH_GUEST_REQUEST_HISTORY: "/content/guestrequesthistory",
  FETCH_CVA_LANDING_PAGE: "/content/landingpagecva",
  FETCH_CVA_DOWNLOAD_PAGES: "/content/downloadcva",
  FORMER_FETCH_REQUEST_HISTORY: "/former_request_history",
  RESEND_PASSWORD_KEY: "/resend_file_password_key",
  FETCH_FORMER_CUSTOMER_LANDING: "content/formerlandingpage",
  ACTIVE_CUSTOMER_CHECK_PENDING_CASE: "/fetch_active_pending_case" ,
  ACTIVE_CUSTOMER_CREATE_PROFILE: "/createorupdate_active_case_id",
  ACTIVE_CUSTOMER_DOCUMENT_VERIFICATION: "/doc_verification_residencyproof_active",
  AGENT_CHECK_PENDING_CASE: "/fetch_agent_pending_case" ,
  AGENT_CREATE_PROFILE: "/createorupdate_agent_case_id",
  AGENT_DOCUMENT_VERIFICATION: "/doc_verification_residencyproof_agent"
  
};